module.exports = __webpack_public_path__ + "static/media/Sanomat Grab Web-Bold Italic.801a4278.woff";